import * as React from 'react';
import {OTPCodeInput} from "../../pages/ActivateCard/sections/OTPModalInput";
import {
    ButtonGroupContainer,
    Form,
    SectionContainer
} from "../../../shared/Layout.styles";
import {FormProvider, useForm} from "react-hook-form";
import {Markdown} from "../../../shared/markdown";
import {Button} from "../../../shared/formElements/button";
import axios from "axios";
import {useState} from "react";
import { ModalStyle} from "./OTPModal.styles";
import { otpModalConstants } from '../../../utils/constants/otpmodal';



export const OTPModal = ({open, handleClose, handleIsAuthed, phone,}: {
    open: boolean
    handleClose: () => void,
    handleIsAuthed: (token:string) => void
    phone: string
}) => {
    const [serverErrors, setServerErrors] = useState('');
    const methods = useForm({
        mode: 'onBlur',
        shouldFocusError: true,
        defaultValues: {
            otpCode: '',
            phoneNumber: '',
        },
    });
    const onOtpSubmit = async (formData: any) => {
        setServerErrors("");
        const data = {
            phone: phone,
            otp_code: formData.otpCode,
        };
        try{
            const response = await axios.post('/v1/authoriseotp', data, {
                headers: {
                    'X-API-Key': process.env.REACT_APP_VAULT_API_KEY || ''
                },
            });
            await handleIsAuthed(response.data.token)

        }
        catch (err:any) {
            console.log('err', err);
            if (err.response.status === 400 || err.response.status === 401) {
                setServerErrors(err.response.data.message);
            }
        }
    }

    return (
            <ModalStyle
                open={open}
                onClose={handleClose}
            >
                <FormProvider {...methods}>
                    <Form onSubmit={methods.handleSubmit(onOtpSubmit)}>
                    <SectionContainer align={"center"}>
                        <Markdown children={otpModalConstants.heading} />
                        <Markdown children={otpModalConstants.subheading} />
                        <OTPCodeInput />
                        {serverErrors && (
                            <Markdown
                                children={serverErrors}
                                className="validationText"
                            />
                        )}
                        <ButtonGroupContainer>
                            <Button
                                type="submit"
                                onClick={() => {
                                    methods.handleSubmit(onOtpSubmit);
                                }}
                            >
                                {'Submit'}
                            </Button>
                        </ButtonGroupContainer>
                    </SectionContainer>
                </Form>
                </FormProvider>
            </ ModalStyle>
    );
}